import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import 'prop-types';
import { Button } from '@andes/button';

/**
 * Service interface
 */
class Service {
  static getQueryParams(url) {
    const {
      searchParams
    } = new URL(url);
    const queryParams = [];
    searchParams.forEach((value, key) => queryParams.push({
      key,
      value
    }));
    return queryParams;
  }
}
const SeoAnchor = _ref => {
  let {
    className,
    href,
    children,
    onClick,
    wrapSimplifySeoAnchor
  } = _ref;
  const namespace = 'seo-ui-anchor';
  const queryParams = Service.getQueryParams(href);
  const propagateParams = queryParams => queryParams.map(queryParam => propagateParam(queryParam.key, queryParam.value));
  const propagateParam = (queryParamKey, queryParamValue) => {
    return /*#__PURE__*/_jsx("input", {
      name: queryParamKey,
      value: queryParamValue,
      type: "hidden"
    });
  };
  const getButtonWithProps = () => {
    return /*#__PURE__*/_jsx(Button, {
      className: `${namespace}__button ${className}`,
      hierarchy: "transparent",
      size: "large",
      type: "submit",
      fullWidth: true,
      role: "link",
      onClick: onClick
    }, void 0, children);
  };
  if (wrapSimplifySeoAnchor) {
    return getButtonWithProps();
  }
  return /*#__PURE__*/_jsx("form", {
    action: href
  }, void 0, propagateParams(queryParams), getButtonWithProps());
};
SeoAnchor.displayName = 'SeoAnchor';
export { SeoAnchor as default };
